(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-product-card"] && !Shopify.designMode) return;
  try {
    const collapsibleToggles = document.querySelectorAll('.collapsible-product-card__details-toggle');
  const mobileBreakpoint = 750;

  collapsibleToggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const targetId = toggle.getAttribute('aria-controls');
      const content = document.getElementById(targetId);
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;

      // On mobile, scroll to show content at top of viewport when expanding
      if (!isExpanded && window.innerWidth < mobileBreakpoint) {
        const productCard = toggle.closest('.collapsible-product-card__product');
        if (productCard) {
          requestAnimationFrame(() => {
            const headerHeight =
              parseInt(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
            const elementTop = productCard.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: elementTop - headerHeight, behavior: 'smooth' });
          });
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.section--fixed').forEach(section => {
    const bg = section.querySelector('.custom-section-background');
    const media = bg?.querySelector('.background-image-container');
    if (!bg || !media) return;

    const range = 300;
    let ticking = false;

    function update() {
      const rect = bg.getBoundingClientRect();
      const viewH = window.innerHeight;
      const progress = Math.min(Math.max((viewH - rect.top) / (viewH + rect.height), 0), 1);
      media.style.transform = 'translateY(' + (progress * range - range * 0.5) + 'px)';
      ticking = false;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', onScroll, { passive: true });
          update();
        } else {
          window.removeEventListener('scroll', onScroll);
        }
      });
    });

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    observer.observe(bg);
  });
  } catch(e) { console.error(e); }
})();

})();
